import SignalRHubs from 'stores/business/hubs/SignalRHubs';
import {fastInvokeAPIPromise} from 'lib/fastSignalRHelper';
import {throwErrorWithData} from 'lib/errorHelper';
import {FastRobotErrorcode, SignalRBackupAndRestoreEvent, SignalRHub} from '../../constants/dataEnum';

const getHub = () => SignalRHubs.getHub(SignalRHub.BACKUP_AND_RESTORE);

export const prepareBackupData = async (userId) => {
  const hub = getHub();
  const response = await fastInvokeAPIPromise(hub, SignalRBackupAndRestoreEvent.PREPARE_BACKUP, userId);

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in preparing backup data', response);
  }

  return response;
};

export const prepareRestoreData = async (userId, includeConfig) => {
  const hub = getHub();
  const response = await fastInvokeAPIPromise(hub, SignalRBackupAndRestoreEvent.EXECUTE_RESTORE, userId, includeConfig);

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in preparing restore data', response);
  }

  return response;
};

export const getBackupRestoreStatus = async () => {
  const hub = getHub();
  const response = await fastInvokeAPIPromise(hub, SignalRBackupAndRestoreEvent.GET_BACKUP_RESTORE_STATUS);

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in getting backup restore status', response);
  }

  return response;
};

export const resetBackupRestoreStatus = async () => {
  const hub = getHub();
  const response = await fastInvokeAPIPromise(hub, SignalRBackupAndRestoreEvent.RESET_BACKUP_RESTORE_STATUS);

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in resetting backup restore status', response);
  }

  return response;
};
